import type { HumanMessageDisplayContext } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { getEffectiveDisplayContext } from '../../ui/chat-history/display-context';

type PromptContextDisplayState = 'runStart' | 'continued' | 'none';

export const getPromptContextDisplayState = ({
	currentDisplayContext,
	previousDisplayContext,
}: {
	currentDisplayContext: HumanMessageDisplayContext | null | undefined;
	previousDisplayContext: HumanMessageDisplayContext | null | undefined;
}): PromptContextDisplayState => {
	const currentEffectiveDisplayContext = getEffectiveDisplayContext(currentDisplayContext);
	if (!currentEffectiveDisplayContext) {
		return 'none';
	}

	const previousEffectiveDisplayContext = getEffectiveDisplayContext(previousDisplayContext);
	return currentEffectiveDisplayContext.identity === previousEffectiveDisplayContext?.identity
		? 'continued'
		: 'runStart';
};
